module.exports = "/_next/static/images/1-3d359c15a96bbb8000f74332de6009f1.png";